import _ from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import {
    GET_COURSE_LIST,
    ADD_COURSE,
    DELETE_COURSE,
} from "./Courses.action.react";
import {
    RENAME_COURSE,
    CHANGE_COURSE_IMAGE,
} from "../../editor/redux/CourseEditor.action.react";

const initialCoursesState = [];

const CoursesReducer = (state = initialCoursesState, action) => {
    let courses, thisCourse;
    switch (action.type) {
        /* istanbul ignore next - react-persist function */
        case REHYDRATE:
            courses = action.payload.courses;
            if (courses) {
                return [...state, ...courses];
            } else {
                return state;
            }
        case GET_COURSE_LIST:
            if (
                action.data.license === "Admin" ||
                action.data.license === "Superadmin"
            ) {
                return action.data.courses;
            } else {
                return _.filter(action.data.courses, (course) => {
                    if (course.owner) {
                        return course.owner._id === action.data.userId;
                    }
                });
            }
        case ADD_COURSE:
            return action.data === null || action.data === undefined
                ? state
                : [...state, action.data.course];
        case DELETE_COURSE:
            courses = _.cloneDeep(state);
            _.remove(courses, {
                id: action.data.id,
            });
            return courses;
        case RENAME_COURSE:
            courses = _.cloneDeep(state);
            thisCourse = _.find(courses, {
                _id: action.data.id,
            });
            thisCourse.name = action.data.name;
            thisCourse.description = action.data.description;
            thisCourse.parent = {
                _id: action.data.category,
                id: action.data.category,
            };
            thisCourse.points = action.data.points;
            thisCourse.coins = action.data.coins;
            return courses;
        case CHANGE_COURSE_IMAGE:
            courses = _.cloneDeep(state);
            thisCourse = _.find(courses, {
                _id: action.data.id,
            });
            thisCourse.image = action.data.image;
            return courses;
        default:
            return state;
    }
};

export { CoursesReducer };
